const textProps = {
  bgImage:
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80",
  title: "Your story starts with us.",
  description:
    "This is a simple example of a Landing Page you can build using Notus PRO React. It features multiple CSS components based on the Tailwind CSS design system.",
};
export default textProps;
